import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../utils/data-load-error/data-load-error";

export enum OrderCancelOrderErrorType {
  ORDER_CANCELLED = "ORDER_CANCELLED",
  PASSENGER_ON_BOARD = "PASSENGER_ON_BOARD",
}

export type OrderCancelOrderCancelledError = DataLoadError<
  OrderCancelOrderErrorType.ORDER_CANCELLED,
  {}
>;

export type OrderCancelOrderPassengerOnboardError = DataLoadError<
  OrderCancelOrderErrorType.PASSENGER_ON_BOARD,
  {}
>;

type OrderCancelOrderError =
  | DataLoadDefaultErrors
  | OrderCancelOrderCancelledError
  | OrderCancelOrderPassengerOnboardError;

export default OrderCancelOrderError;
